import * as React from "react";
const SvgFiRrSnooze = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-snooze_svg__a)">
      <path
        fill="#062147"
        d="M2.031 21.685a.43.43 0 0 0 .434.315H10a1 1 0 1 1 0 2H2.465A2.42 2.42 0 0 1 .13 22.307a2.425 2.425 0 0 1 .881-2.748l7.804-5.729a.435.435 0 0 0 .164-.515.43.43 0 0 0-.434-.315H1.011a1 1 0 1 1 0-2h7.535c1.082 0 1.998.665 2.335 1.693a2.43 2.43 0 0 1-.88 2.749l-7.805 5.729a.434.434 0 0 0-.164.514M23.002 20h-3.805l4.02-3.517a1.9 1.9 0 0 0 .691-2.155A1.9 1.9 0 0 0 22.076 13H18a1 1 0 1 0 0 2h3.88l-4.02 3.517a1.9 1.9 0 0 0-.69 2.155A1.9 1.9 0 0 0 19 22h4.002a1 1 0 1 0 0-2M19 9a1 1 0 0 0-1-1l-4.995-.042 5.155-4.236a2.03 2.03 0 0 0 .74-2.304 2.03 2.03 0 0 0-1.958-1.419h-4.938a1 1 0 0 0 0 2L17 2.041l-5.156 4.236a2.03 2.03 0 0 0-.739 2.304 2.03 2.03 0 0 0 1.957 1.418H18a1 1 0 0 0 1-1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-snooze_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSnooze;
